import { makeRequest } from '../../../../lib/api';
import {
  AddNewTireBrandRequestInterface,
  AddNewTireModelRequestInterface,
} from '../../api/tireStorageApi';

const CATALOG_TIRE_PATH = '/v1/catalog/vehicle/tires';

const tireStorageController = {
  getTireBrandsResponse: (showDeleted = false): Promise<any> => {
    return makeRequest('get', `${ CATALOG_TIRE_PATH }/brands?showDeleted=${ showDeleted }`);
  },

  addNewTireBrand: (request:AddNewTireBrandRequestInterface): Promise<any> => {
    return makeRequest('post', `${ CATALOG_TIRE_PATH }/brands`, request);
  },

  getTireModelsResponse: (showDeleted = false, brandId:number): Promise<any> => {
    return makeRequest('get', `${ CATALOG_TIRE_PATH }/models?showDeleted=${ showDeleted }&brandId=${ brandId }`);
  },

  addNewTireModel: (request:AddNewTireModelRequestInterface): Promise<any> => {
    return makeRequest('post', `${ CATALOG_TIRE_PATH }/models`, request);
  },

};

export { tireStorageController };
